let layoutAuth = { layout: 'auth' }
let app = { layout: 'default', middleware: 'auth' }

export default [
    {
        name: 'login',
        path: '/',
        component: () => import('~/pages/auth/login.vue'),
        meta: layoutAuth,
    },

    {
        name: 'register',
        path: '/sign-up',
        component: () => import('~/pages/auth/register.vue'),
        meta: layoutAuth,
    },

    {
        name: 'forgot-password',
        path: '/forgot-password',
        component: () => import('~/pages/auth/forgot.vue'),
        meta: layoutAuth,
    },
    {
        path: '/forgot-password/:token',
        component: () => import('~/pages/auth/forgot.vue'),
        meta: layoutAuth,
        props: true,
    },

    {
        path: '/email-verification',
        component: () => import('~/pages/auth/email-verification.vue'),
        meta: { layout: 'auth', middleware: 'auth' },
    },
    {
        path: '/sms-verification',
        component: () => import('~/pages/auth/sms-verification.vue'),
        meta: { layout: 'auth', middleware: 'auth' },
    },
];